import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';


const columns = [
    {
        Header: ' ',
        cellProps: { className: 'ps-1' },
        Cell: rowData => {
            const { idLicencia } = rowData.row.original;
            return <>
                <Link to={"/licencias/detalle/" + idLicencia} >
                    <img title="Ver informaci&oacute;n" src="/img/ver20.png"></img>
                </Link>
            </>
        }
    },
    {
        accessor: 'idLicencia',
        Header: 'ID',
        cellProps: { className: 'ps-1' },
        Cell: rowData => {
            const { idLicencia } = rowData.row.original;
            return <Link to={"/licencias/detalle/" + idLicencia}><span>{idLicencia}</span></Link>
        }
    },
    {
        accessor: 'vDescripcionTipo',
        Header: 'Tipo Licencia',
        cellProps: { className: 'ps-1' },
        Cell: rowData => {
            const { vDescripcionTipo } = rowData.row.original;
            return <span>{vDescripcionTipo}</span>
        }
    },
    {
        accessor: 'vNombreVendedor',
        Header: 'Vendedor',
        cellProps: { className: 'ps-1' },
        Cell: rowData => {
            const { vNombreVendedor } = rowData.row.original;
            return <span> {vNombreVendedor}</span>;
        }
    },
    {
        accessor: 'vNombreCliente',
        Header: 'Nombre Cliente',
        cellProps: { className: 'ps-1' },
        Cell: rowData => {
            const { vNombreCliente } = rowData.row.original;
            return <span> {vNombreCliente}</span>;
        }
    },
    {
        accessor: 'vNombreEmpresa',
        Header: 'Nombre Empresa',
        headerProps: { className: 'pe-1' },
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { vNombreEmpresa, idLicencia } = rowData.row.original;
            return (
                <>
                    <h5 className="mb-0 fs--2">
                        <Link to={"/licencias/detalle/" + idLicencia}>
                            <span className="d-inline-block text-truncate" style={{ maxWidth: '250px' }}>
                                {vNombreEmpresa}
                            </span>
                        </Link>
                    </h5>
                </>
            );
        }
    },
    {
        accessor: 'vLatLon',
        Header: 'Lat Lon',
        Cell: rowData => {
            const { vLatLon } = rowData.row.original;
            return <a href={"https://www.google.com/maps/place/" + vLatLon} target="_blank" rel="noreferrer"><span className="d-inline-block text-truncate" style={{ maxWidth: '250px' }}>{vLatLon}</span></a>;
        }
    },
    {
        accessor: 'vLatLonSistema',
        Header: 'LatLonSistema',
        Cell: rowData => {
            const { vLatLonSistema } = rowData.row.original;
            return <a href={"https://www.google.com/maps/place/" + vLatLonSistema} target="_blank" rel="noreferrer"><span>{vLatLonSistema}</span></a>
        }
    }
];

const LicenciasInfoIncompleta = () => {
    const [customers, setCustomers] = useState([]);
    const [cargando, setCargando] = useState(true);
    const navigate = useNavigate();
    const { token, name, usuario, setToken } = useToken();
    const { vFiltro } = useParams();
    const [vendedores, setVendedores] = useState([]);
    const { showErrorToast } = useToast();

    const mostrarLicencias = async (vUsuario) => {
        setCargando(true);
        const response = await fetch("/api/licencia/ObtenerLicenciasInfoIncompleta/?vFiltro=" + vFiltro + "&vUsuario=" + vUsuario,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
        if (response.ok) {
            const data = await response.json();
            console.log(data['table1']);
            setCustomers(data['table1']);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    const ObtenerDatosVendedores = async () => {
        setCargando(true);
        const response = await fetch("/api/usuario/ObtenerDatosVendedores",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            setVendedores(data);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
        mostrarLicencias(usuario)
    };

    useEffect(() => {
        ObtenerDatosVendedores();
    }, []);

    return (
        <>
            <PageHeader
                title={"Errores en " + vFiltro + " de la licencia"}
                className="mb-1"
            >
            </PageHeader>
            <AdvanceTableWrapper
                columns={columns}
                data={customers}
                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header className="d-flex flex-between-center">
                        <IconButton
                            onClick={() => navigate(-1)}
                            variant="falcon-default"
                            size="sm"
                            icon="arrow-left"
                        />

                    </Card.Header>
                </Card>
                <Card >
                    <Card.Header>
                        <h3>{name},</h3><h5>En esta tabla puedes visualizar las licencias que tienen las coordenadas repetidas o incorrectas. Por favor rev&iacute;salos detenidamente y corrija la informaci&oacute;n de cada uno.</h5>

                    </Card.Header>
                    <Card.Body>
                        <Row className="flex-between-center">
                            <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    onChange={(event) => mostrarLicencias(event.target.value)}
                                    defaultValue={usuario}
                                >
                                    <option value="">Todos los vendedores</option>
                                    <option value="NoAsignados">No asignados</option>
                                    {vendedores.map((vendedor, index) => {
                                        return (<option key={index} value={vendedor.vUsuario}>{vendedor.vUsuario}</option>)
                                    })}

                                </Form.Select>
                            </Col>
                        </Row>
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--2 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={customers.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            {cargando && (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)}
        </>
    );
};

export default LicenciasInfoIncompleta;
